import React from "react";
import { useStore } from "../../../../models";
import styles from "./deleteConfirmation.css";
import { CancelRemovingButton } from "./deleteConfirmButtons/cancelButton";
import { ConfirmRemovingButton } from "./deleteConfirmButtons/confirmRemovingButton";
import {
  DeletingState,
  Props as DeletingProps,
  useDeleteConfirmationState
} from "./useDeleteConfirmationState";

interface Props extends DeletingProps {
  areYouSureText: string;
  succesfullyDeletedText: string;
  renderComponent(onDeleteClick: () => void): JSX.Element;
}
export const DeleteConfirmation = ({
  areYouSureText,
  succesfullyDeletedText,
  renderComponent,
  ...rest
}: Props) => {
  const { state, setState, onRemove } = useDeleteConfirmationState(rest);

  const renderPrompt = () => {
    return (
      <div className={styles.prompt}>
        <div className={styles["placeholder-div"]} />
        <p className={styles.text}>
          {state === DeletingState.AwaitingAction ? areYouSureText : succesfullyDeletedText}
        </p>
        {state === DeletingState.AwaitingAction ? (
          <div className={styles.actions}>
            <CancelRemovingButton onClick={() => setState(DeletingState.Pristine)} />
            <ConfirmRemovingButton onClick={onRemove} />
          </div>
        ) : (
          <div className={styles["placeholder-div"]} />
        )}
      </div>
    );
  };

  return (
    <div className={styles.container}>
      {renderComponent(() => setState(DeletingState.AwaitingAction))}
      {state !== DeletingState.Pristine && renderPrompt()}
    </div>
  );
};

export const DeleteConfirmationToastOnError = (props: Omit<Props, "onError">) => {
  const { uiStore } = useStore();

  return <DeleteConfirmation {...props} onError={() => uiStore.addGenericErrorToast()} />;
};
